import {createContext, useContext} from 'react'

export type DrawerContextType = {
  onClose?: VoidFunction
  isFullSize: boolean
  opened: boolean
}

const DrawerContext = createContext<DrawerContextType | null>(null)

export const DrawerContextProvider = DrawerContext.Provider as React.Provider<DrawerContextType>

export const DrawerContextConsumer = DrawerContext.Consumer as React.Consumer<DrawerContextType>

export const useDrawerContext = (): DrawerContextType => {
  const context = useContext(DrawerContext)
  if (context === null) {
    throw new Error('useDrawerContext должен находиться внутри Drawer!')
  }
  return context
}
